(function ($) {
    $(document).ready(function () {
        let swiperImage
        let swiperVideo
        var app = {
            audio: {
                player: null,
            },
            video: {
                player: null,
                el: null,
                done: false,
            },
            map: {
                map: null,
                markers: [],
            },
            isMobile: false,
            isTablet: false,
            isMaxTablet: false,
            breakPointMenuBurger: 1200,
            breakPointMaxTablet: 1024,
            breakPointTablet: 992,
            breakPointMobile: 881,
            navHeight: 105,
            navHeightMobile: 80,
            navBreakpoint: 1199,
            init: function () {
                // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
                let vh = window.innerHeight * 0.01;
                // Then we set the value in the --vh custom property to the root of the document
                document.documentElement.style.setProperty("--vh", `${vh}px`);
                app.handleResize();
                app.responsiveDetection();
                app.swiperPictos();
                app.swiperLinkedin();
                app.swiperMag();
                app.swiperVideo()
                app.swiperImage()
                app.swiperImageExplicatives()
            },

            handleResize: function () {
                $(window).on("resize", function () {
                    app.swiperImage()
                    app.responsiveDetection();
                });
            },
            responsiveDetection: function () {
                app.isMobile = $(window).width() < app.breakPointMobile;
                app.isTablet = $(window).width() < app.breakPointTablet;
                app.isMaxTablet = $(window).width() <= app.breakPointMaxTablet;
            },
            swiperPictos: function () {
                if ($(".swiper-pictos").length) {
                    // SWIPER PICTOS
                    var swiper = new Swiper(".swiper-pictos", {
                        slidesPerView: 1.3,
                        spaceBetween: 28,
                        pagination: {
                            el: ".swiper-pictos-pagination",
                            clickable: true,
                        },
                        navigation: {
                            nextEl: ".swiper-pictos-next",
                            prevEl: ".swiper-pictos-prev",
                        },
                        breakpoints: {
                            640: {
                                slidesPerView: 2,
                            },
                            1400: {
                                slidesPerView: 4,
                            },
                        },
                    });
                }
            },

            swiperLinkedin: function () {
                if ($(".swiper-linkedin").length > 0) {
                    // SWIPER LINKEDIN
                    var swiper = new Swiper(".swiper-linkedin", {
                        //watchSlidesProgress: true,
                        slidesPerView: 1.2,
                        spaceBetween: 28,
                        pagination: {
                            el: ".swiper-linkedin-pagination",
                            clickable: true,
                        },
                        navigation: {
                            nextEl: ".swiper-linkedin-next",
                            prevEl: ".swiper-linkedin-prev",
                        },
                        breakpoints: {
                            991: {
                                slidesPerView: 2,
                            },
                            1023: {
                                slidesPerView: 3,
                            },
                        },
                    });
                }
            },
            swiperMag: function () {
                if ($(".swiper-mag").length > 0) {
                    const breakpoint = window.matchMedia("(max-width:1023px)");
                    let swiperMag;

                    const breakpointChecker = function () {
                        // if larger viewport and multi-row layout needed
                        if (breakpoint.matches === false) {
                            // clean up old instances and inline styles when available
                            if (swiperMag !== undefined) swiperMag.destroy(true, true);
                            // or/and do nothing
                            return;
                            // else if a small viewport and single column layout needed
                        } else if (breakpoint.matches === true) {
                            // fire small viewport version of swiper
                            return enableSwiper();
                        }
                    };

                    const enableSwiper = function () {
                        swiperMag = new Swiper(".swiper-mag", {
                            // loop: true,
                            slidesPerView: "auto",

                            // Navigation arrows
                            navigation: {
                                nextEl: ".swiper-mag-next",
                                prevEl: ".swiper-mag-prev",
                            },

                            // pagination
                            pagination: {
                                el: ".swiper-mag-pagination",
                                clickable: true,
                            },
                            // paginationClickable: true,
                        });
                    };

                    // keep an eye on viewport size changes
                    breakpoint.addListener(breakpointChecker);
                    breakpointChecker();
                }
            },
            swiperVideo: function () {
                if ($(".swiper-video").length > 0) {

                    let getAutoplay = $(".swiper-video").data("autoplay")

                    function removeSwiperVideo() {
                        swiperVideo.destroy()
                        swiperVideo = undefined
                    }

                    function initSwiperVideo() {
                        if (swiperVideo === undefined) {
                            swiperVideo = new Swiper(".swiper-video", {
                                slidesPerView: 1.5,
                                spaceBetween: 20,
                                disableOnInteraction: false,
                                centeredSlides: true,
                                loop: true,
                                autoplay: {
                                    delay: 2500,
                                },
                                navigation: {
                                    nextEl: ".swiper-image-video-next",
                                    prevEl: ".swiper-image-video-prev",
                                },
                            });
                        }
                        if (getAutoplay !== 1) {
                            swiperVideo.autoplay.stop()
                        }
                        $(".swiper-video").on("mouseleave", function () {
                            if (!swiperVideo.autoplay.running && getAutoplay === 1 ) {
                                swiperVideo.autoplay.start()
                            }
                        })
                    }

                    function checker() {
                        if (app.isMobile) {
                            if (swiperVideo !== undefined) removeSwiperVideo();
                            return;
                        }

                        initSwiperVideo();
                    }

                    checker()

                    const mediaQuery = `(max-width: ${app.breakPointMobile}px)`;
                    const mediaQueryList = window.matchMedia(mediaQuery);

                    mediaQueryList.addEventListener('change',  checker);

                    let dataVideo = null
                    //Display popin video
                    $(".cta-video").on("click", function (e) {
                        e.preventDefault()
                        dataVideo = $(this).data("video-url")


                        if($(this).attr("data-target-modal") === "video") {
                            $(".popin-video video").attr("src", dataVideo)
                            $(".popin-video").removeClass("hidden")
                        } else if ($(this).attr("data-target-modal") === "youtube"){
                            $(".frame-container div").attr("videoid", dataVideo)
                            $(".frame-container iframe").attr("src", "https://www.youtube.com/embed/" + dataVideo + "?autoplay=1")
                            $(".popin-youtube").removeClass("hidden")
                        }
                    })
                    //Close popin video
                    $(".popin-video .close,  .popin-video").on("click", function (e) {
                        e.preventDefault()
                        if (e.target.className === "video") {
                            return
                        }
                        $(".popin-video video").attr("src", "")
                        $(".popin-video").addClass("hidden")
                    })

                    $(".popin-youtube .close, .popin-youtube").on("click", function (e) {
                        e.preventDefault()
                        if ( e.target.className === "frame-container") {
                            return
                        }
                        $(".popin-youtube").addClass("hidden")
                        $(".frame-container div").attr("videoid", "")
                        $(".frame-container iframe").attr("src", "")
                    })
                }
            },
            swiperImage: function () {
                if ($(".swiper-image").length > 0) {

                    const getAutoplay = $(".swiper-image").data("autoplay");

                    function initSwiper() {

                        let swiperParams= {
                            slidesPerView: 1.2,
                            spaceBetween: 20,
                            centeredSlides: true,
                            disableOnInteraction: false,
                            loop: true,
                            breakpoints: {
                                881: {
                                    slidesPerView: 1.5,
                                    navigation: {
                                        nextEl: ".swiper-image-video-next",
                                        prevEl: ".swiper-image-video-prev",
                                    },
                                },
                            },
                            pagination: {
                                el: ".swiper-mag-pagination",
                                clickable: true,
                            },
                            navigation: {
                                nextEl: ".swiper-mag-next",
                                prevEl: ".swiper-mag-prev",
                            },
                        };
                        if (getAutoplay == 1) {
                            swiperParams.autoplay = {
                                delay: 2500
                            };
                        } else {
                            swiperParams.autoplay = {
                                disableOnInteraction:true
                            }
                        }
                        swiperImage = new Swiper(".swiper-image", swiperParams);
                    }

                    if (swiperImage === undefined) {
                        initSwiper()
                    }

                    if (app.isMobile) {
                        if (swiperImage !== undefined) {
                            swiperImage.destroy();
                            swiperImage = undefined;
                            initSwiper()
                        }
                    }

                    if (getAutoplay !== 1) {
                        swiperImage.autoplay.stop();
                    }

                    $(".swiper-image").on("mouseleave", function () {
                        if (!swiperImage.autoplay.running && getAutoplay == 1) {
                            swiperImage.autoplay.start()
                        }
                    })
                }
            },
            swiperImageExplicatives: function () {
                const swiperContainers = document.querySelectorAll('.popin-text-img');
                let scrollTop;

                for (let i = 0; i < swiperContainers.length; i++) {


                    swiperContainers[i].classList.add('swiper-container-' + i);

                    let swiperExplicatives = new Swiper('.swiper-container-' + i + ' .swiper-explicative_images', {
                        slidesPerView: 1,
                        centeredSlides: true,
                        loop: false,
                        navigation: {
                            nextEl: ".swiper-image-video-next",
                            prevEl: ".swiper-image-video-prev",
                        },
                    });

                    const parentElement = swiperContainers[i].closest('.block-image-text, .block-image-text-reverse');
                    if (parentElement) {
                        const ctaImages = parentElement.querySelectorAll('.cta-image');
                        for (let j = 0; j < ctaImages.length; j++) {
                            ctaImages[j].classList.add('open-slider-' + i);
                        }
                    }
                    document.querySelectorAll('.open-slider-' + i).forEach(function (element, index) {
                        element.addEventListener('click', function (e) {
                            e.preventDefault();
                            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                            document.querySelector('body').classList.add('scroll-disabled');
                            document.querySelector('body').style.top = -scrollTop + 'px';
                            swiperContainers[i].classList.remove('hidden');
                            swiperExplicatives.slideTo(index);
                        });
                    })

                    document.querySelectorAll('.popin-text-img .close').forEach(function (element) {
                        element.addEventListener('click', function (e) {
                            e.preventDefault();
                            document.querySelector('body').classList.remove('scroll-disabled');
                            swiperContainers[i].classList.add('hidden');
                            document.querySelector('body').removeAttribute('style');
                            window.scrollTo({top: scrollTop, left: 0, behavior: 'instant'});

                        });
                    })
                }

            }


        };
        app.init();
    });
})(jQuery);
